import * as angular from "angular";
import template from "./entity-effective-ranges-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityEffectiveRangesTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityEffectiveRangesTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewEffectiveRanges = globs.entityTypes.byType(this.typeConfig.Code).effective.byCode("*").read;
		this.tab = {
			name: "Effective Ranges",
			code: "EFFECTIVE_RANGES",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewEffectiveRanges)
				&& isSupportedOrNullish(this.typeConfig.EffectiveRanges)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-effective-ranges-tab", [])
	.component("entityEffectiveRangesTab", {
		controller: EntityEffectiveRangesTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
